import React, { useContext } from 'react';
import { Form, Icon, Input } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import MaskedInput from 'react-text-mask';
import { Context } from '../../Context';
import DocumentUpload from '../Shared/DocumentUpload';

const DentalPlanDetails = props => {

  // context
  const {
    formData,
    updateField,
    errors,
    addError,
    validationErrors,
    documents,
    mapDocuments,
    submissionInfo
  } = useContext( Context );

  // props
  const { refs } = props;

  return (
    <div className="dental-plan-details">
      <fieldset>
        <Form.Field
          width={ 8 }
          required
          error={ 'dentalRenewalDate' in errors }
        >
          <label>When is your dental plan renewal date?</label>
          <DatePicker
          type="date"
            disabled={ submissionInfo.benefits.isComplete }
            ref={ refs.dentalRenewalDateInput }
            isClearable
            selected={ formData.dentalRenewalDate ? new Date( formData.dentalRenewalDate ) : null }
            customInput={
              <MaskedInput
                mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                keepCharPositions= {true}
                guide = {true}
              />
            }
            onChange={ e => { updateField({ target: { name: "dentalRenewalDate", value: e } }) } }
            onBlur={ () => addError({ name: 'dentalRenewalDate' , error: validationErrors[ 'dentalRenewalDate' ] }) }
            onKeyDown={ e => {
              if ( e.key === "Tab" ) {
                refs.dentalRenewalDateInput.current.setOpen( false );
              }
            }}
          />
        </Form.Field>
        <Form.Field
          width={ 8 }
          required
          error={ 'dentalPlanVendor' in errors }
        >
          <label>Who is your dental plan vendor?</label>
          <Input
            disabled={ submissionInfo.benefits.isComplete }
            ref={ refs.dentalPlanVendorInput }
            name="dentalPlanVendor"
            value={ formData.dentalPlanVendor || '' }
            onChange={ updateField }
            onBlur={ e => addError({ name: e.target.name, error: validationErrors[ e.target.name ] }) }
          />
        </Form.Field>
        { submissionInfo.benefits.isComplete
          ? <>
              <br />
              <Icon name="file alternate outline" />
              <span style={{ fontWeight: '700' }}>Dental Plan Summary:</span>
              &nbsp;
              <span>{ documents.dentalSummary ? mapDocuments( documents.dentalSummary, true ) : 'No document uploaded' }</span>
              <br />
            </>
          : <>
              <br />
              <Form.Field>
                <label>Please attach your dental plan summary.</label>
              </Form.Field>
              <DocumentUpload typeID={ 40 } />
              { documents.dentalSummary ? mapDocuments( documents.dentalSummary ) : null }
            </>
        }
        { submissionInfo.benefits.isComplete
          ? <>
              <br />
              <Icon name="file alternate outline" />
              <span style={{ fontWeight: '700' }}>Dental Insurance Invoice:</span>
              &nbsp;
              <span>{ documents.dentalInvoice ? mapDocuments( documents.dentalInvoice, true ) : 'No document uploaded' }</span>
            </>
          : <>
              <br />
              <Form.Field>
                <label>Please attach your most recent dental insurance invoice.</label>
              </Form.Field>
              <DocumentUpload typeID={ 41 } />
              { documents.dentalInvoice ? mapDocuments( documents.dentalInvoice ) : null }
            </>
        }
      </fieldset>
    </div>
  );
}

export default DentalPlanDetails;
